// As requested by client - from list shopify uses.
// There are multiple copies in the project, search for them.
const countryOptions = [
	{
		value: "AF",
		label: "Afghanistan",
		flag: "🇦🇫",
		color: "#000000",
		secondaryColor: "#009E49",
		colorCategory: "Black",
	},
	{
		value: "AX",
		label: "Åland Islands",
		flag: "🇦🇽",
		color: "#0057B7",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "AL",
		label: "Albania",
		flag: "🇦🇱",
		color: "#E30A17",
		secondaryColor: "#000000",
		colorCategory: "Red",
	},
	{
		value: "DZ",
		label: "Algeria",
		flag: "🇩🇿",
		color: "#006233",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "AD",
		label: "Andorra",
		flag: "🇦🇩",
		color: "#D52B1E",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "AO",
		label: "Angola",
		flag: "🇦🇴",
		color: "#C8102E",
		secondaryColor: "#000000",
		colorCategory: "Red",
	},
	{
		value: "AI",
		label: "Anguilla",
		flag: "🇦🇮",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Navy",
	},
	{
		value: "AG",
		label: "Antigua & Barbuda",
		flag: "🇦🇬",
		color: "#CE1126",
		secondaryColor: "#000000",
		colorCategory: "Red",
	},
	{
		value: "AR",
		label: "Argentina",
		flag: "🇦🇷",
		color: "#75AADB",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "AM",
		label: "Armenia",
		flag: "🇦🇲",
		color: "#D90012",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "AW",
		label: "Aruba",
		flag: "🇦🇼",
		color: "#002B7F",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "AC",
		label: "Ascension Island",
		flag: "🇦🇨",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Navy",
	},
	{
		value: "AU",
		label: "Australia",
		flag: "🇦🇺",
		color: "#006B3F",
		secondaryColor: "#FFCD00",
		colorCategory: "Navy",
	},
	{
		value: "AT",
		label: "Austria",
		flag: "🇦🇹",
		color: "#ED2939",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "AZ",
		label: "Azerbaijan",
		flag: "🇦🇿",
		color: "#3F9C35",
		secondaryColor: "#ED2939",
		colorCategory: "Green",
	},
	{
		value: "BS",
		label: "Bahamas",
		flag: "🇧🇸",
		color: "#00778B",
		secondaryColor: "#FFD700",
		colorCategory: "Teal",
	},
	{
		value: "BH",
		label: "Bahrain",
		flag: "🇧🇭",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "BD",
		label: "Bangladesh",
		flag: "🇧🇩",
		color: "#006A4E",
		secondaryColor: "#FF0000",
		colorCategory: "Green",
	},
	{
		value: "BB",
		label: "Barbados",
		flag: "🇧🇧",
		color: "#00267F",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "BY",
		label: "Belarus",
		flag: "🇧🇾",
		color: "#D52B1E",
		secondaryColor: "#009739",
		colorCategory: "Red",
	},
	{
		value: "BE",
		label: "Belgium",
		flag: "🇧🇪",
		color: "#000000",
		secondaryColor: "#FFD90F",
		colorCategory: "Black",
	},
	{
		value: "BZ",
		label: "Belize",
		flag: "🇧🇿",
		color: "#003F87",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "BJ",
		label: "Benin",
		flag: "🇧🇯",
		color: "#008751",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "BM",
		label: "Bermuda",
		flag: "🇧🇲",
		color: "#012169",
		secondaryColor: "#FF0000",
		colorCategory: "Navy",
	},
	{
		value: "BT",
		label: "Bhutan",
		flag: "🇧🇹",
		color: "#FF4E12",
		secondaryColor: "#FFD700",
		colorCategory: "Orange",
	},
	{
		value: "BO",
		label: "Bolivia",
		flag: "🇧🇴",
		color: "#007934",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "BA",
		label: "Bosnia & Herzegovina",
		flag: "🇧🇦",
		color: "#002395",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "BW",
		label: "Botswana",
		flag: "🇧🇼",
		color: "#000000",
		secondaryColor: "#FFFFFF",
		colorCategory: "Black",
	},
	{
		value: "BR",
		label: "Brazil",
		flag: "🇧🇷",
		color: "#009C3B",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "IO",
		label: "British Indian Ocean Territory",
		flag: "🇮🇴",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Navy",
	},
	{
		value: "VG",
		label: "British Virgin Islands",
		flag: "🇻🇬",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "BN",
		label: "Brunei",
		flag: "🇧🇳",
		color: "#F7E017",
		secondaryColor: "#FFFFFF",
		colorCategory: "Yellow",
	},
	{
		value: "BG",
		label: "Bulgaria",
		flag: "🇧🇬",
		color: "#00966E",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "BF",
		label: "Burkina Faso",
		flag: "🇧🇫",
		color: "#EF2B2D",
		secondaryColor: "#009E60",
		colorCategory: "Red",
	},
	{
		value: "BI",
		label: "Burundi",
		flag: "🇧🇮",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "KH",
		label: "Cambodia",
		flag: "🇰🇭",
		color: "#032EA1",
		secondaryColor: "#FF0000",
		colorCategory: "Blue",
	},
	{
		value: "CM",
		label: "Cameroon",
		flag: "🇨🇲",
		color: "#007A5E",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "CA",
		label: "Canada",
		flag: "🇨🇦",
		color: "#D52B1E",
		secondaryColor: "#00247D",
		colorCategory: "Red",
	},
	{
		value: "CV",
		label: "Cape Verde",
		flag: "🇨🇻",
		color: "#003893",
		secondaryColor: "#FFFFFF",
		colorCategory: "Navy",
	},
	{
		value: "BQ",
		label: "Caribbean Netherlands",
		flag: "🇧🇶",
		color: "#21468B",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "KY",
		label: "Cayman Islands",
		flag: "🇰🇾",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "CF",
		label: "Central African Republic",
		flag: "🇨🇫",
		color: "#003082",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "TD",
		label: "Chad",
		flag: "🇹🇩",
		color: "#002664",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "CL",
		label: "Chile",
		flag: "🇨🇱",
		color: "#D52B1E",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "CN",
		label: "China",
		flag: "🇨🇳",
		color: "#DE2910",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "CX",
		label: "Christmas Island",
		flag: "🇨🇽",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "CC",
		label: "Cocos (Keeling) Islands",
		flag: "🇨🇨",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "CO",
		label: "Colombia",
		flag: "🇨🇴",
		color: "#FCD116",
		secondaryColor: "#003893",
		colorCategory: "Yellow",
	},
	{
		value: "KM",
		label: "Comoros",
		flag: "🇰🇲",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "CG",
		label: "Congo - Brazzaville",
		flag: "🇨🇬",
		color: "#009543",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "CD",
		label: "Congo - Kinshasa",
		flag: "🇨🇩",
		color: "#007FFF",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "CK",
		label: "Cook Islands",
		flag: "🇨🇰",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "CR",
		label: "Costa Rica",
		flag: "🇨🇷",
		color: "#002B7F",
		secondaryColor: "#FFFFFF",
		colorCategory: "Navy",
	},
	{
		value: "HR",
		label: "Croatia",
		flag: "🇭🇷",
		color: "#171796",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "CW",
		label: "Curaçao",
		flag: "🇨🇼",
		color: "#002B7F",
		secondaryColor: "#FFD700",
		colorCategory: "Navy",
	},
	{
		value: "CY",
		label: "Cyprus",
		flag: "🇨🇾",
		color: "#D57800",
		secondaryColor: "#FFFFFF",
		colorCategory: "Yellow",
	},
	{
		value: "CZ",
		label: "Czechia",
		flag: "🇨🇿",
		color: "#D7141A",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "CI",
		label: "Côte d'Ivoire",
		flag: "🇨🇮",
		color: "#F77F00",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "DK",
		label: "Denmark",
		flag: "🇩🇰",
		color: "#C60C30",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "DJ",
		label: "Djibouti",
		flag: "🇩🇯",
		color: "#6AB2E7",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "DM",
		label: "Dominica",
		flag: "🇩🇲",
		color: "#006B3F",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "DO",
		label: "Dominican Republic",
		flag: "🇩🇴",
		color: "#002D62",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "EC",
		label: "Ecuador",
		flag: "🇪🇨",
		color: "#FFD100",
		secondaryColor: "#00247D",
		colorCategory: "Yellow",
	},
	{
		value: "EG",
		label: "Egypt",
		flag: "🇪🇬",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SV",
		label: "El Salvador",
		flag: "🇸🇻",
		color: "#0F47AF",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "GQ",
		label: "Equatorial Guinea",
		flag: "🇬🇶",
		color: "#3E9A00",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "ER",
		label: "Eritrea",
		flag: "🇪🇷",
		color: "#EA0437",
		secondaryColor: "#009E60",
		colorCategory: "Green",
	},
	{
		value: "EE",
		label: "Estonia",
		flag: "🇪🇪",
		color: "#0072CE",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "SZ",
		label: "Eswatini",
		flag: "🇸🇿",
		color: "#3E5EB9",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "ET",
		label: "Ethiopia",
		flag: "🇪🇹",
		color: "#078930",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "FK",
		label: "Falkland Islands",
		flag: "🇫🇰",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Navy",
	},
	{
		value: "FO",
		label: "Faroe Islands",
		flag: "🇫🇴",
		color: "#FFFFFF",
		secondaryColor: "#00247D",
		colorCategory: "Navy",
	},
	{
		value: "FJ",
		label: "Fiji",
		flag: "🇫🇯",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "FI",
		label: "Finland",
		flag: "🇫🇮",
		color: "#002F6C",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "FR",
		label: "France",
		flag: "🇫🇷",
		color: "#002395",
		secondaryColor: "#ED2939",
		colorCategory: "Blue",
	},
	{
		value: "GF",
		label: "French Guiana",
		flag: "🇬🇫",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "PF",
		label: "French Polynesia",
		flag: "🇵🇫",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "TF",
		label: "French Southern Territories",
		flag: "🇹🇫",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "GA",
		label: "Gabon",
		flag: "🇬🇦",
		color: "#009E60",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "GM",
		label: "Gambia",
		flag: "🇬🇲",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "GE",
		label: "Georgia",
		flag: "🇬🇪",
		color: "#FF0000",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "DE",
		label: "Germany",
		flag: "🇩🇪",
		color: "#000000",
		secondaryColor: "#FF0000",
		colorCategory: "Black",
	},
	{
		value: "GH",
		label: "Ghana",
		flag: "🇬🇭",
		color: "#006B3F",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "GI",
		label: "Gibraltar",
		flag: "🇬🇮",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "GR",
		label: "Greece",
		flag: "🇬🇷",
		color: "#0D5EAF",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "GL",
		label: "Greenland",
		flag: "🇬🇱",
		color: "#FFFFFF",
		secondaryColor: "#D52B1E",
		colorCategory: "Red",
	},
	{
		value: "GD",
		label: "Grenada",
		flag: "🇬🇩",
		color: "#CE1126",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "GP",
		label: "Guadeloupe",
		flag: "🇬🇵",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "GT",
		label: "Guatemala",
		flag: "🇬🇹",
		color: "#4997D0",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "GG",
		label: "Guernsey",
		flag: "🇬🇬",
		color: "#F1BF00",
		secondaryColor: "#FFFFFF",
		colorCategory: "Yellow",
	},
	{
		value: "GN",
		label: "Guinea",
		flag: "🇬🇳",
		color: "#CE1126",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "GW",
		label: "Guinea-Bissau",
		flag: "🇬🇼",
		color: "#CE1126",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "GY",
		label: "Guyana",
		flag: "🇬🇾",
		color: "#009E49",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "HT",
		label: "Haiti",
		flag: "🇭🇹",
		color: "#00209F",
		secondaryColor: "#FF0000",
		colorCategory: "Red",
	},
	{
		value: "HN",
		label: "Honduras",
		flag: "🇭🇳",
		color: "#0073CF",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "HK",
		label: "Hong Kong SAR",
		flag: "🇭🇰",
		color: "#DE2910",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "HU",
		label: "Hungary",
		flag: "🇭🇺",
		color: "#436F4D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "IS",
		label: "Iceland",
		flag: "🇮🇸",
		color: "#02529C",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "IN",
		label: "India",
		flag: "🇮🇳",
		color: "#FF9933",
		secondaryColor: "#138808",
		colorCategory: "Yellow",
	},
	{
		value: "ID",
		label: "Indonesia",
		flag: "🇮🇩",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "IR",
		label: "Iran",
		flag: "🇮🇷",
		color: "#DA0000",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "IQ",
		label: "Iraq",
		flag: "🇮🇶",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "IE",
		label: "Ireland",
		flag: "🇮🇪",
		color: "#169B62",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "IM",
		label: "Isle of Man",
		flag: "🇮🇲",
		color: "#EF2B2D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "IL",
		label: "Israel",
		flag: "🇮🇱",
		color: "#0038B8",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "IT",
		label: "Italy",
		flag: "🇮🇹",
		color: "#009246",
		secondaryColor: "#CE2B37",
		colorCategory: "Red",
	},
	{
		value: "JM",
		label: "Jamaica",
		flag: "🇯🇲",
		color: "#000000",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "JP",
		label: "Japan",
		flag: "🇯🇵",
		color: "#BC002D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "JE",
		label: "Jersey",
		flag: "🇯🇪",
		color: "#F1BF00",
		secondaryColor: "#FFFFFF",
		colorCategory: "Yellow",
	},
	{
		value: "JO",
		label: "Jordan",
		flag: "🇯🇴",
		color: "#007A3D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "KZ",
		label: "Kazakhstan",
		flag: "🇰🇿",
		color: "#00AFCA",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "KE",
		label: "Kenya",
		flag: "🇰🇪",
		color: "#000000",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "KI",
		label: "Kiribati",
		flag: "🇰🇮",
		color: "#CE1126",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "XK",
		label: "Kosovo",
		flag: "🇽🇰",
		color: "#244AA5",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "KW",
		label: "Kuwait",
		flag: "🇰🇼",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "KG",
		label: "Kyrgyzstan",
		flag: "🇰🇬",
		color: "#FF0000",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "LA",
		label: "Laos",
		flag: "🇱🇦",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "LV",
		label: "Latvia",
		flag: "🇱🇻",
		color: "#9E3039",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "LB",
		label: "Lebanon",
		flag: "🇱🇧",
		color: "#EE161F",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "LS",
		label: "Lesotho",
		flag: "🇱🇸",
		color: "#00247D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "LR",
		label: "Liberia",
		flag: "🇱🇷",
		color: "#002868",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "LY",
		label: "Libya",
		flag: "🇱🇾",
		color: "#239E46",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "LI",
		label: "Liechtenstein",
		flag: "🇱🇮",
		color: "#002B7F",
		secondaryColor: "#FF0000",
		colorCategory: "Red",
	},
	{
		value: "LT",
		label: "Lithuania",
		flag: "🇱🇹",
		color: "#FDB913",
		secondaryColor: "#006A44",
		colorCategory: "Yellow",
	},
	{
		value: "LU",
		label: "Luxembourg",
		flag: "🇱🇺",
		color: "#00A1DE",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "MO",
		label: "Macao SAR",
		flag: "🇲🇴",
		color: "#DE2910",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "MG",
		label: "Madagascar",
		flag: "🇲🇬",
		color: "#FC3D32",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "MW",
		label: "Malawi",
		flag: "🇲🇼",
		color: "#CE1126",
		secondaryColor: "#000000",
		colorCategory: "Green",
	},
	{
		value: "MY",
		label: "Malaysia",
		flag: "🇲🇾",
		color: "#010066",
		secondaryColor: "#FFFFFF",
		colorCategory: "Yellow",
	},
	{
		value: "MV",
		label: "Maldives",
		flag: "🇲🇻",
		color: "#D21034",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "ML",
		label: "Mali",
		flag: "🇲🇱",
		color: "#14B53A",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "MT",
		label: "Malta",
		flag: "🇲🇹",
		color: "#CF142B",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "MQ",
		label: "Martinique",
		flag: "🇲🇶",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "MR",
		label: "Mauritania",
		flag: "🇲🇷",
		color: "#006233",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "MU",
		label: "Mauritius",
		flag: "🇲🇺",
		color: "#EA2839",
		secondaryColor: "#1A206D",
		colorCategory: "Red",
	},
	{
		value: "YT",
		label: "Mayotte",
		flag: "🇾🇹",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "MX",
		label: "Mexico",
		flag: "🇲🇽",
		color: "#006341",
		secondaryColor: "#CE1126",
		colorCategory: "Red",
	},
	{
		value: "MD",
		label: "Moldova",
		flag: "🇲🇩",
		color: "#FFD700",
		secondaryColor: "#0033A0",
		colorCategory: "Green",
	},
	{
		value: "MC",
		label: "Monaco",
		flag: "🇲🇨",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "MN",
		label: "Mongolia",
		flag: "🇲🇳",
		color: "#C4272F",
		secondaryColor: "#0066B3",
		colorCategory: "Red",
	},
	{
		value: "ME",
		label: "Montenegro",
		flag: "🇲🇪",
		color: "#D0A650",
		secondaryColor: "#C8102E",
		colorCategory: "Red",
	},
	{
		value: "MS",
		label: "Montserrat",
		flag: "🇲🇸",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "MA",
		label: "Morocco",
		flag: "🇲🇦",
		color: "#C1272D",
		secondaryColor: "#006233",
		colorCategory: "Red",
	},
	{
		value: "MZ",
		label: "Mozambique",
		flag: "🇲🇿",
		color: "#007168",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "MM",
		label: "Myanmar (Burma)",
		flag: "🇲🇲",
		color: "#FECB00",
		secondaryColor: "#EA2839",
		colorCategory: "Yellow",
	},
	{
		value: "NA",
		label: "Namibia",
		flag: "🇳🇦",
		color: "#003580",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "NR",
		label: "Nauru",
		flag: "🇳🇷",
		color: "#002B7F",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "NP",
		label: "Nepal",
		flag: "🇳🇵",
		color: "#DC143C",
		secondaryColor: "#003893",
		colorCategory: "Red",
	},
	{
		value: "NL",
		label: "Netherlands",
		flag: "🇳🇱",
		color: "#21468B",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "NC",
		label: "New Caledonia",
		flag: "🇳🇨",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "NZ",
		label: "New Zealand",
		flag: "🇳🇿",
		color: "#00247D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "NI",
		label: "Nicaragua",
		flag: "🇳🇮",
		color: "#0066CC",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "NE",
		label: "Niger",
		flag: "🇳🇪",
		color: "#E05206",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "NG",
		label: "Nigeria",
		flag: "🇳🇬",
		color: "#008751",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "NU",
		label: "Niue",
		flag: "🇳🇺",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "NF",
		label: "Norfolk Island",
		flag: "🇳🇫",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "MK",
		label: "North Macedonia",
		flag: "🇲🇰",
		color: "#D20000",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "NO",
		label: "Norway",
		flag: "🇳🇴",
		color: "#EF2B2D",
		secondaryColor: "#00247D",
		colorCategory: "Red",
	},
	{
		value: "OM",
		label: "Oman",
		flag: "🇴🇲",
		color: "#DB161B",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "PK",
		label: "Pakistan",
		flag: "🇵🇰",
		color: "#01411C",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "PS",
		label: "Palestinian Territories",
		flag: "🇵🇸",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "PA",
		label: "Panama",
		flag: "🇵🇦",
		color: "#005293",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "PG",
		label: "Papua New Guinea",
		flag: "🇵🇬",
		color: "#000000",
		secondaryColor: "#FF0000",
		colorCategory: "Green",
	},
	{
		value: "PY",
		label: "Paraguay",
		flag: "🇵🇾",
		color: "#0038A8",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "PE",
		label: "Peru",
		flag: "🇵🇪",
		color: "#D91023",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "PH",
		label: "Philippines",
		flag: "🇵🇭",
		color: "#0038A8",
		secondaryColor: "#CE1126",
		colorCategory: "Red",
	},
	{
		value: "PN",
		label: "Pitcairn Islands",
		flag: "🇵🇳",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "PL",
		label: "Poland",
		flag: "🇵🇱",
		color: "#DC143C",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "PT",
		label: "Portugal",
		flag: "🇵🇹",
		color: "#006600",
		secondaryColor: "#FF0000",
		colorCategory: "Red",
	},
	{
		value: "QA",
		label: "Qatar",
		flag: "🇶🇦",
		color: "#8D1B3D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "RE",
		label: "Réunion",
		flag: "🇷🇪",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "RO",
		label: "Romania",
		flag: "🇷🇴",
		color: "#002B7F",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "RU",
		label: "Russia",
		flag: "🇷🇺",
		color: "#D52B1E",
		secondaryColor: "#0039A6",
		colorCategory: "Red",
	},
	{
		value: "RW",
		label: "Rwanda",
		flag: "🇷🇼",
		color: "#00A1DE",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "WS",
		label: "Samoa",
		flag: "🇼🇸",
		color: "#CE1126",
		secondaryColor: "#00247D",
		colorCategory: "Red",
	},
	{
		value: "SM",
		label: "San Marino",
		flag: "🇸🇲",
		color: "#5CACEE",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "ST",
		label: "São Tomé & Príncipe",
		flag: "🇸🇹",
		color: "#12AD2B",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "SA",
		label: "Saudi Arabia",
		flag: "🇸🇦",
		color: "#245C36",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SN",
		label: "Senegal",
		flag: "🇸🇳",
		color: "#00853F",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "RS",
		label: "Serbia",
		flag: "🇷🇸",
		color: "#C6363C",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SC",
		label: "Seychelles",
		flag: "🇸🇨",
		color: "#D62828",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "SL",
		label: "Sierra Leone",
		flag: "🇸🇱",
		color: "#0072C6",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "SG",
		label: "Singapore",
		flag: "🇸🇬",
		color: "#ED2939",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SX",
		label: "Sint Maarten",
		flag: "🇸🇽",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SK",
		label: "Slovakia",
		flag: "🇸🇰",
		color: "#0B4EA2",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SI",
		label: "Slovenia",
		flag: "🇸🇮",
		color: "#005EB8",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SB",
		label: "Solomon Islands",
		flag: "🇸🇧",
		color: "#005EB8",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "SO",
		label: "Somalia",
		flag: "🇸🇴",
		color: "#4189DD",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "ZA",
		label: "South Africa",
		flag: "🇿🇦",
		color: "#007A4D",
		secondaryColor: "#DE3831",
		colorCategory: "Green",
	},
	{
		value: "GS",
		label: "South Georgia & South Sandwich Islands",
		flag: "🇬🇸",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "KR",
		label: "South Korea",
		flag: "🇰🇷",
		color: "#003478",
		secondaryColor: "#CE1126",
		colorCategory: "Red",
	},
	{
		value: "SS",
		label: "South Sudan",
		flag: "🇸🇸",
		color: "#078930",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "ES",
		label: "Spain",
		flag: "🇪🇸",
		color: "#F1BF00",
		secondaryColor: "#C60B1E",
		colorCategory: "Red",
	},
	{
		value: "LK",
		label: "Sri Lanka",
		flag: "🇱🇰",
		color: "#FFB700",
		secondaryColor: "#8D1B3D",
		colorCategory: "Yellow",
	},
	{
		value: "BL",
		label: "St. Barthélemy",
		flag: "🇧🇱",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "SH",
		label: "St. Helena",
		flag: "🇸🇭",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "KN",
		label: "St. Kitts & Nevis",
		flag: "🇰🇳",
		color: "#009E49",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "LC",
		label: "St. Lucia",
		flag: "🇱🇨",
		color: "#65CFFF",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "MF",
		label: "St. Martin",
		flag: "🇲🇫",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "PM",
		label: "St. Pierre & Miquelon",
		flag: "🇵🇲",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "VC",
		label: "St. Vincent & Grenadines",
		flag: "🇻🇨",
		color: "#007A5E",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "SD",
		label: "Sudan",
		flag: "🇸🇩",
		color: "#D21034",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "SR",
		label: "Suriname",
		flag: "🇸🇷",
		color: "#377E3F",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "SJ",
		label: "Svalbard & Jan Mayen",
		flag: "🇸🇯",
		color: "#EF2B2D",
		secondaryColor: "#00247D",
		colorCategory: "Blue",
	},
	{
		value: "SE",
		label: "Sweden",
		flag: "🇸🇪",
		color: "#005B99",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "CH",
		label: "Switzerland",
		flag: "🇨🇭",
		color: "#FF0000",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TW",
		label: "Taiwan",
		flag: "🇹🇼",
		color: "#FE0000",
		secondaryColor: "#000095",
		colorCategory: "Red",
	},
	{
		value: "TJ",
		label: "Tajikistan",
		flag: "🇹🇯",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TZ",
		label: "Tanzania",
		flag: "🇹🇿",
		color: "#1EB53A",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "TH",
		label: "Thailand",
		flag: "🇹🇭",
		color: "#ED1C24",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TL",
		label: "Timor-Leste",
		flag: "🇹🇱",
		color: "#DC241F",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "TG",
		label: "Togo",
		flag: "🇹🇬",
		color: "#006A4E",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "TK",
		label: "Tokelau",
		flag: "🇹🇰",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "TO",
		label: "Tonga",
		flag: "🇹🇴",
		color: "#C10000",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TT",
		label: "Trinidad & Tobago",
		flag: "🇹🇹",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TA",
		label: "Tristan da Cunha",
		flag: "🇹🇦",
		color: "#012169",
		secondaryColor: "#FFFFFF",
		colorCategory: "Blue",
	},
	{
		value: "TN",
		label: "Tunisia",
		flag: "🇹🇳",
		color: "#E70013",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TR",
		label: "Türkiye",
		flag: "🇹🇷",
		color: "#E30A17",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "TM",
		label: "Turkmenistan",
		flag: "🇹🇲",
		color: "#00843D",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "TC",
		label: "Turks & Caicos Islands",
		flag: "🇹🇨",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "TV",
		label: "Tuvalu",
		flag: "🇹🇻",
		color: "#012169",
		secondaryColor: "#FFD700",
		colorCategory: "Blue",
	},
	{
		value: "UM",
		label: "U.S. Outlying Islands",
		flag: "🇺🇲",
		color: "#B22234",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "UG",
		label: "Uganda",
		flag: "🇺🇬",
		color: "#FCDD09",
		secondaryColor: "#000000",
		colorCategory: "Green",
	},
	{
		value: "UA",
		label: "Ukraine",
		flag: "🇺🇦",
		color: "#005BBB",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "AE",
		label: "United Arab Emirates",
		flag: "🇦🇪",
		color: "#EF3340",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "GB",
		label: "United Kingdom",
		flag: "🇬🇧",
		color: "#012169",
		secondaryColor: "#CF142B",
		colorCategory: "Blue",
	},
	{
		value: "US",
		label: "United States",
		flag: "🇺🇸",
		color: "#B22234",
		secondaryColor: "#3C3B6E",
		colorCategory: "Red",
	},
	{
		value: "UY",
		label: "Uruguay",
		flag: "🇺🇾",
		color: "#0038A8",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "UZ",
		label: "Uzbekistan",
		flag: "🇺🇿",
		color: "#1EB53A",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "VU",
		label: "Vanuatu",
		flag: "🇻🇺",
		color: "#FDCE12",
		secondaryColor: "#009543",
		colorCategory: "Green",
	},
	{
		value: "VA",
		label: "Vatican City",
		flag: "🇻🇦",
		color: "#FFE000",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "VE",
		label: "Venezuela",
		flag: "🇻🇪",
		color: "#CF142B",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
	{
		value: "VN",
		label: "Vietnam",
		flag: "🇻🇳",
		color: "#DA251D",
		secondaryColor: "#FFD700",
		colorCategory: "Red",
	},
	{
		value: "WF",
		label: "Wallis & Futuna",
		flag: "🇼🇫",
		color: "#002395",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "EH",
		label: "Western Sahara",
		flag: "🇪🇭",
		color: "#007A3D",
		secondaryColor: "#FFFFFF",
		colorCategory: "Green",
	},
	{
		value: "YE",
		label: "Yemen",
		flag: "🇾🇪",
		color: "#CE1126",
		secondaryColor: "#FFFFFF",
		colorCategory: "Red",
	},
	{
		value: "ZM",
		label: "Zambia",
		flag: "🇿🇲",
		color: "#198A00",
		secondaryColor: "#FF0000",
		colorCategory: "Green",
	},
	{
		value: "ZW",
		label: "Zimbabwe",
		flag: "🇿🇼",
		color: "#006400",
		secondaryColor: "#FFD700",
		colorCategory: "Green",
	},
];

export default countryOptions;
